<template>
  <v-dialog width="800px" :value="value" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbPink" dark flat>
        <div class="text-h6">{{ $t('general.setResponsible') }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal(false)">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col class="text-center kbGrayText--text mt-10" cols="12" >
            <h3>{{ $t('general.selectResponsibleSolo') }}</h3>
          </v-col>
        </v-row>
        <v-col class="pa-2 text-center" cols="12">
          <v-row justify="center">
            <v-autocomplete
              class="pa-5"
              color="kbDarkBlueText"
              :items="administrators"
              item-text="fullName"
              item-value="userId"
              :label="$t('general.pickAResponsible')"
              outlined
              :search-input.sync="search"
              style="max-width: 500px"
              v-model="responsibleId"
            />
          </v-row>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red"
               class="mr-2"
               outlined
               @click="toggleModal(false)">{{ $t('general.cancel') }}</v-btn>
        <v-btn color="kbPink"
               dark
               :loading="editingUser"
               @click="submit">{{ $t('general.saveChanges') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import { mapState, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapState({
      selectedUser: state => state.users.selectedUser
    }),
    ...mapGetters([
      'administrators',
      'companyUuid'
    ])
  },
  data () {
    return {
      editingUser: false,
      responsibleId: '',
      search: ''
    }
  },
  methods: {
    clearSelectedUser () {
      this.$store.commit('SET_SELECTED_USER', {})
      this.$emit('clearSelectedUser')
    },
    async getAdministrators () {
      await this.$store.dispatch('getAdministrators')
    },
    async getUser () {
      try {
        await this.$store.dispatch('getUser', { userId: this.user })
        this.responsibleId = this.selectedUser.responsibleId || ''
      } catch (e) {
        console.log(e)
      }
    },
    onSelectedResponsibleChange (responsibleId) {
      this.responsibleId = responsibleId
    },
    submit () {
      this.editingUser = true
      this.$store.dispatch('updateUser', {
        userId: this.user,
        responsibleId: this.responsibleId
      }).then(() => {
        notifications.success('Responsible changed')
        this.editingUser = false
        this.toggleModal(false)
      }).catch(error => {
        notifications.error(error.message)
        this.editingUser = false
      })
    },
    toggleModal (value) {
      this.clearSelectedUser()
      this.$emit('input', value)
      this.responsibleId = ''
    }
  },
  props: ['user', 'value'],
  watch: {
    user (value) {
      if (value) {
        this.getUser()
      }
    },
    value (value) {
      if (value) {
        this.$store.commit('SET_PAGINATION_USERS_COMPANY', {
          page: 1,
          itemsPerPage: 300,
          sortBy: [],
          sortDesc: []
        })
        this.getAdministrators()
      }
    }
  }
}
</script>
